import { render, staticRenderFns } from "./isProfile.vue?vue&type=template&id=0afbce8e&scoped=true&"
import script from "./isProfile.vue?vue&type=script&lang=js&"
export * from "./isProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afbce8e",
  null
  
)

export default component.exports